import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { name: 'About', path: '#about' },
    { name: 'Work', path: '#work' },
    { name: 'Skills', path: '#skills' },
    { name: 'Writing', path: '/writing' },
    { name: 'Demos', path: '/demos' },
    { name: 'Contact', path: '/contact' }
  ];

  const handleHashLinkClick = (e, sectionId) => {
    e.preventDefault();
    
    // If not on homepage, navigate to homepage first, then scroll
    if (location.pathname !== '/') {
      navigate('/');
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      // Already on homepage, just scroll
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-[#E5E5E5] shadow-sm">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-4 sm:py-5 lg:py-6">
        <div className="flex justify-between items-center">
          <Link 
            to="/" 
            className="text-xl sm:text-2xl font-serif tracking-tight text-[#1A1A1A] hover:text-teal-600 transition-colors duration-300 font-bold"
          >
            <span className="sm:hidden">UB</span>
            <span className="hidden sm:inline">UDDESHYA</span>
          </Link>
          
          <ul className="flex items-center gap-4 sm:gap-5 md:gap-6 lg:gap-8">
            {navItems.map((item) => {
              const isHashLink = item.path.startsWith('#');
              const isActive = isHashLink 
                ? false 
                : location.pathname === item.path;
              
              // Hide Writing and Demos on mobile to reduce congestion
              const isMobileHidden = (item.name === 'Writing' || item.name === 'Demos');
              
              if (isHashLink) {
                return (
                  <li key={item.path} className={isMobileHidden ? 'hidden md:block' : ''}>
                    <a
                      href={item.path}
                      className="text-sm sm:text-base font-medium tracking-wide transition-all duration-300 hover:text-teal-600 text-[#2A2A2A] whitespace-nowrap"
                      onClick={(e) => handleHashLinkClick(e, item.path.substring(1))}
                    >
                      {item.name}
                    </a>
                  </li>
                );
              }
              
              return (
                <li key={item.path} className={isMobileHidden ? 'hidden md:block' : ''}>
                  <Link
                    to={item.path}
                    className={`text-sm sm:text-base font-medium tracking-wide transition-all duration-300 hover:text-teal-600 whitespace-nowrap ${
                      isActive
                        ? 'text-teal-600 font-semibold'
                        : 'text-[#2A2A2A]'
                    }`}
                  >
                    {item.name}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Header;
